import React from "react";
import { ShieldWarning, X, Plus, Phone, Trash } from "@phosphor-icons/react";

export function EmergencyContactsModal({ contacts, onAdd, onDelete, onClose, embedded }) {
  const body = (
    <>
      <p className="text-slate-500 text-sm mb-4">Avisaremos a estas personas si activas el botón de pánico durante un viaje.</p>
      <form onSubmit={onAdd} className="space-y-2 mb-4">
        <input name="name" className="input-field" placeholder="Nombre" required data-testid="contact-name-input" />
        <input name="phone" className="input-field" placeholder="Teléfono" required data-testid="contact-phone-input" />
        <input name="email" type="email" className="input-field" placeholder="Email (opcional)" data-testid="contact-email-input" />
        <button type="submit" className="btn-primary w-full" data-testid="add-contact-btn">
          <Plus size={16} className="inline mr-1" weight="bold" /> Añadir contacto
        </button>
      </form>
      <div className="space-y-2">
        {contacts.length === 0 && <p className="text-slate-400 text-sm text-center py-4">Aún no tienes contactos.</p>}
        {contacts.map((c) => (
          <div key={c.id} className="flex items-center justify-between bg-slate-50 rounded-xl p-3" data-testid={`contact-item-${c.id}`}>
            <div className="min-w-0">
              <div className="font-bold truncate">{c.name}</div>
              <div className="text-xs text-slate-500 flex items-center gap-1"><Phone size={12} weight="duotone" />{c.phone}{c.email ? ` · ${c.email}` : ""}</div>
            </div>
            <button onClick={() => onDelete(c.id)} className="text-red-600 hover:bg-red-50 rounded-lg p-2 shrink-0" data-testid={`delete-contact-${c.id}`}>
              <Trash size={16} weight="duotone" />
            </button>
          </div>
        ))}
      </div>
    </>
  );

  if (embedded) {
    return (
      <div className="app-section" data-testid="security-section">
        <div className="flex items-center gap-2 mb-4">
          <ShieldWarning size={26} weight="duotone" className="text-red-500" />
          <h2 className="section-title font-display" style={{ marginBottom: 0 }}>Seguridad</h2>
        </div>
        {body}
      </div>
    );
  }

  return (
    <div className="absolute inset-0 z-[1200] bg-slate-900/60 flex items-center justify-center p-4" data-testid="contacts-modal">
      <div className="bg-white rounded-3xl p-6 w-full max-w-md fade-in max-h-[85vh] overflow-auto">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <ShieldWarning size={24} weight="duotone" className="text-red-600" />
            <h2 className="font-display text-xl font-bold">Contactos de emergencia</h2>
          </div>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center"><X size={18} /></button>
        </div>
        {body}
      </div>
    </div>
  );
}
